<greco-simple-dialog [data]="dialogData">
  <greco-select-from-source
    (confirmed)="confirmed($event)"
    [source]="data?.source || 'vimeo'"
  ></greco-select-from-source>
</greco-simple-dialog>
